// custom-tag.component.ts
import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';
import { STATUS_COLORS_TAG } from '@models/global-entities.model';

@Component({
  selector: 'app-custom-tag',
  standalone: true,
  imports: [NgIf, LucideIconsModule],
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() status: string = '';
  @Input() value: string = '';
  @Input() isDot: boolean = true;
  @Input() direction: 'up' | 'down' | null = null;

  get severity(): string {
    const statusColors: { [key: string]: string } = STATUS_COLORS_TAG;
    return statusColors[this.status] || 'primary';
  }
}
